module.exports = __webpack_public_path__ + "static/img/wdzt1-5.33f8b03.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-5.png
// module id = 853
// module chunks = 0